var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsOptional, IsString, IsUUID } from 'class-validator';
/**
 * One Zuzahlungsbefreiung nach § 62 SGB V as the patient file shows it (#1496).
 *
 * ⚠ `validTo` is the **last covered day**, not the first uncovered one. A `null`
 * means "bis auf Weiteres".
 */
export class CopaymentExemptionResponseDto {
    id;
    patientId;
    /** First covered day, inclusive. `YYYY-MM-DD`. */
    validFrom;
    /** Last covered day, inclusive, or `null` for an open end. `YYYY-MM-DD`. */
    validTo;
    /** What the practice noted off the Bescheinigung. Free text, no upload. */
    note;
    createdAt;
    updatedAt;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CopaymentExemptionResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CopaymentExemptionResponseDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CopaymentExemptionResponseDto.prototype, "validFrom", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CopaymentExemptionResponseDto.prototype, "validTo", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CopaymentExemptionResponseDto.prototype, "note", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CopaymentExemptionResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CopaymentExemptionResponseDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=copayment-exemption.response.dto.js.map